import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { components, util } from '@glowforge/ui-common';
import Dialog from 'app/common/components/dialog';
import { formatPrice } from 'app/util';
import ComparisonTable from 'app/common/components/comparison-table/comparison-table';
import ProductList from './product-list';
import { productPropType } from './product-selector';
import OrderFooter from './order-footer';
import ComparisonDataContainer from './comparison-data-container';

import './order-page-form-lite.less';

const { Button, Markdown } = components;

const { analytics: {
  gtmEvent,
} } = util;

class OrderPageForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showComparisonDialog: false,
      isClient: false,
    };
    this.formSubmitHandler = props.handleSubmit(v => this.formSubmit(v));
  }

  componentDidMount() {
    // This is necessary because redux-form does not fully support SSR. Initial
    // values will be `undefined`, which means the HTML rendered by the server
    // will not match what is rendered by the client. We have to use the
    // workaround described here to force the client to re-render:
    // https://reactjs.org/docs/react-dom.html#hydrate
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ isClient: true });

    try {
      gtmEvent('shopify_order_checkout');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }

  toggleComparisonDialog = () => {
    this.setState({ showComparisonDialog: !this.state.showComparisonDialog });
  };

  comparisonDialog = () => {
    if (!this.state.showComparisonDialog) {
      return null;
    }
    return (
      <ComparisonDataContainer>
        {({ comparisonData, products }) => (
          <Dialog
            isOpen
            onRequestClose={this.toggleComparisonDialog}
            actionButtons={<Button onClick={this.toggleComparisonDialog}>Close</Button>}>
            <ComparisonTable comparisonData={comparisonData} products={products} />
          </Dialog>
        )}
      </ComparisonDataContainer>
    );
  };

  shippingInfo = () => {
    const { shippingInfoMarkdown } = this.props;
    const { isClient } = this.state;
    if (!shippingInfoMarkdown || !isClient) return null;
    return <Markdown className='shippingInfo' source={shippingInfoMarkdown} />;
  };

  formSubmit = (values) => {
    this.props.submitOrderToShopify(values, this.props.products, this.props.referralInfo);
  };

  render = () => (
    <form
      className='OrderPageFormLite content'
      onSubmit={this.formSubmitHandler}>
      <div className='topSection'>
        <ProductList {...this.props} />
        <div className='summary'>
          <Button
            className='compareOptions'
            type='secondary'
            size='large'
            onClick={this.toggleComparisonDialog}>
            {this.props.pageStrings['comparison-dialog-button']}
          </Button>
          <div className='subTotal'>
            {this.props.pageStrings['order-subtotal']}
            <span className='totalPrice'> {formatPrice(this.props.subTotal)}</span>
            {this.shippingInfo()}
          </div>
          <Button type='primary' isSubmit>
            {this.props.pageStrings['gf-order-confirm-order-button-proceed']}
          </Button>
          {this.comparisonDialog()}
        </div>
        <OrderFooter {...this.props} />
      </div>
    </form>);
}

OrderPageForm.propTypes = {
  submitOrderToShopify: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  subTotal: PropTypes.number.isRequired,
  pageStrings: PropTypes.objectOf(PropTypes.string).isRequired,
  referralInfo: PropTypes.shape.isRequired,
  products: PropTypes.objectOf(PropTypes.shape(productPropType)).isRequired,
  shippingInfoMarkdown: PropTypes.string.isRequired,
};

OrderPageForm.defaultProps = {};

export default reduxForm({ form: 'glowforgeOrderPage' })(OrderPageForm);



// WEBPACK FOOTER //
// ./app/store/components/glowforge/order-page-form-lite.jsx